import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { Validation } from './enums/validation.enum';

export const genericRegexValidator =
  (pattern: RegExp, errorNmae: Validation): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    return pattern.test(control.value) ? null : { [errorNmae]: true };
  };
